import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from '../../../../../client/app/shared/confirmation-dialog/confirmation-dialog.component';
import { LogService } from '../../../logging/log.service';
import { AuthenticationService } from '../../authentication.service';
import { FopLoginMode } from './../../../fop-mode/fop-mode.model';
import { FopModeService } from './../../../fop-mode/fop-mode.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
    LOG_SOURCE = 'ProfileComponent';

    username: string;
    roles: string[];
    logoutAvailable: boolean;
    sub: Subscription;

    constructor(
        private readonly logService: LogService,
        private readonly authenticationService: AuthenticationService,
        private readonly fopModeService: FopModeService,

        public dialog: MatDialog
    ) {}

    ngOnInit() {
        this.username = this.authenticationService.getUsername();
        this.roles = this.authenticationService.getUserRoles();

        this.sub = this.fopModeService.getFopConfig().subscribe(fopConfig => {
            this.logoutAvailable = fopConfig.fopModeEnabled === false || fopConfig.loginMode === FopLoginMode.UserLogin;
        });
    }

    logout() {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: 'Are you sure you want to log out?'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.logService.info(this.LOG_SOURCE, 'Logging out', {});

                this.authenticationService.logout();
            }
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
